import { createSlice } from "@reduxjs/toolkit";

export const selectionTools = {
  SINGLE: "single",
  DRAW: "draw",
  ERASE: "erase",
};

const initialState = {
  selections: {
    windows: [],
  },
  selectionMode: {
    windows: true,
  },
  tools: {
    drawMode: false,
    selectionTool: selectionTools.SINGLE,
  },
  rectangleUI: {
    isDrawing: false,
    startPoint: null,
    currentPoint: null,
  },
};

const objectType = "windows";
const objectSelectionSlice = createSlice({
  name: "objectSelection",
  initialState,
  reducers: {
    toggleSelectionMode: (state, action) => {
      state.selectionMode[objectType] = !state.selectionMode[objectType];

      if (!state.selectionMode[objectType]) {
        state.selections[objectType] = [];
      }
    },

    deselectObject: (state, action) => {
      const { objectId } = action.payload;
      if (state.selections[objectType]) {
        state.selections[objectType] = state.selections[objectType].filter(
          (id) => id !== objectId
        );
      }
    },

    toggleObjectSelection: (state, action) => {
      const { objectId } = action.payload;
      if (!state.selections[objectType]) {
        state.selections[objectType] = [];
      }

      const isSelected = state.selections[objectType].includes(objectId);

      if (isSelected) {
        state.selections[objectType] = state.selections[objectType].filter(
          (id) => id !== objectId
        );
      } else {
        state.selections[objectType].push(objectId);
      }
    },

    selectMultipleObjects: (state, action) => {
      const { objectIds } = action.payload;
      if (!state.selections[objectType]) {
        state.selections[objectType] = [];
      }
      const existingIds = state.selections[objectType];
      const newIds = objectIds.filter((id) => !existingIds.includes(id));
      state.selections[objectType] = [...existingIds, ...newIds];
    },

    clearSelections: (state, action) => {
      state.selections[objectType] = [];
    },

    setDrawMode: (state, action) => {
      state.tools.drawMode = action.payload;
      if (!action.payload) {
        state.rectangleUI.isDrawing = false;
        state.rectangleUI.startPoint = null;
        state.rectangleUI.currentPoint = null;
      }
    },

    setSelectionTool: (state, action) => {
      state.tools.selectionTool = action.payload;
    },

    setRectangleDrawing: (state, action) => {
      state.rectangleUI.isDrawing = action.payload;
    },

    setRectangleStart: (state, action) => {
      state.rectangleUI.startPoint = action.payload;
    },

    setRectangleCurrent: (state, action) => {
      state.rectangleUI.currentPoint = action.payload;
    },

    clearRectangleUI: (state) => {
      state.rectangleUI.isDrawing = false;
      state.rectangleUI.startPoint = null;
      state.rectangleUI.currentPoint = null;
    },
  },
});

export const {
  toggleSelectionMode,
  deselectObject,
  toggleObjectSelection,
  selectMultipleObjects,
  clearSelections,
  setDrawMode,
  setSelectionTool,
  setRectangleDrawing,
  setRectangleStart,
  setRectangleCurrent,
  clearRectangleUI,
} = objectSelectionSlice.actions;

export const getSelectedObjects = (state) => {
  return state.objectSelection.selections[objectType] || [];
};

export const getSelectionCount = (state) => {
  return state.objectSelection.selections[objectType]?.length || 0;
};

export const isSelectionModeActive = (state) => {
  return state.objectSelection.selectionMode[objectType] || false;
};

export const isDrawMode = (state) => {
  return state.objectSelection.tools.drawMode;
};

export const getSelectionTool = (state) => {
  return state.objectSelection.tools.selectionTool;
};

export default objectSelectionSlice.reducer;
